var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitch = function SvgTwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 453 500"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M324.322 91.4471H290.181V188.4H324.322V91.4471ZM230.491 91.0318H196.35V188.029H230.491V91.0318ZM85.4006 0L0.0981445 80.7973V371.71H102.466V452.507L187.778 371.71H256.05L409.624 226.254V0H85.4006ZM375.492 210.124L307.247 274.748H238.984L179.24 331.311V274.748H102.466V32.3295H375.492V210.124Z"
  })));
};

export default SvgTwitch;